import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import CustomerService from "../../../Customer/Controller/CustomerController";
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import InvoiceService from "../../Controller/InvoiceController";
import { convertCurrency } from "../../../Purchasing/View/PurchaseOrderForms/CurrencyConverter";
export const ShipInvoice = (selectedId) => {
    const navigate = useNavigate();
    const fetchInvoiceDetail = async (selectedId) => {
        try {
            const redirectCallback = () => navigate('/');

            if (selectedId > 0) {
                const saleOrderDetail = await InvoiceService.GetInvoiceByID(redirectCallback, selectedId);
                const saleOrder = saleOrderDetail[0];
                return saleOrder;
            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };

    const fetchInvoiceItems = async (selectedId) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            if (selectedId > 0) {
                const saleOrderDetails = await InvoiceService.GetInvoiceItem(redirectCallback, selectedId);

                const saleOrderDetail = await InvoiceService.GetInvoiceByID(redirectCallback, selectedId);
                const saleOrder = saleOrderDetail[0];

                const listofCustomers = await CustomerService.GetAllCustomers(redirectCallback);
                const selectedCustomer = listofCustomers.find(customer => customer.ClientCompanyID === parseInt(saleOrder.CustomerID));

                const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback);
                const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
                const ConversionRate = await convertCurrency(listOfCurreny[0].Symbol, selectedCustomer.vc_CurrencySymbol, currencyData, "0");

                // Check for depot quantity issue
                const depotIssue = saleOrderDetails.filter(
                    detail => parseFloat(detail.DepotQuantity) < parseFloat(detail.vc_UnitOfSale)
                );
                if (depotIssue.length > 0) {
                    // Show alert and stop submission
                    Swal.fire(
                        'Warning',
                        `Depot quantity for stock is less than required quantity.`,
                        'warning'
                    );
                    return null; // Stop further processing
                }

                // Convert and map the parts
                const selectedPartsData = await Promise.all(saleOrderDetails.map(async (detail) => {
                    const convertedStockPrice = (detail.mon_StockPrice * ConversionRate);
                    const convertedmon_SalesPrice = (detail.mon_SalesPrice * ConversionRate);
                    const convertednet_SalesPrice = (detail.net_SalesPrice * ConversionRate);
                    const converteddetailnet_VATPrice = (detail.net_VATPrice * ConversionRate);
                    const convertedmon_SellingPrice = (detail.mon_SellingPrice * ConversionRate);

                    return {
                        vc_StockCode: detail.vc_StockCode,
                        PK_InvoiceItem_ID: detail.PK_InvoiceItem_ID,
                        vc_Description: detail.vc_Description,
                        mon_StockPrice: convertedStockPrice,
                        mon_SalesPrice: convertedmon_SalesPrice,
                        vc_UnitOfSale: detail.vc_UnitOfSale,
                        net_SalesPrice: convertednet_SalesPrice,
                        net_VATPrice: converteddetailnet_VATPrice,
                        vc_StockName: detail.vc_Description,
                        PK_Stock_ID: detail.FK_Stock_ID,
                        dec_Discount: detail.dec_Discount,
                        mon_SellingPrice: convertedmon_SellingPrice,
                        dec_Delivered: detail.dec_Delivered,
                        dec_OnOrder: detail.dec_OnOrder,
                        FK_Location_ID_Stock: detail.FK_Location_ID_Stock,
                        vc_Name: detail.DepotName,
                        CUnitOfSale: detail.vc_UnitOfSale,
                        dec_QuantityShipped: detail.dec_QuantityShipped,
                        dec_QtyAllocated: detail.dec_QtyAllocated,
                        PK_StockLocation_ID: detail.PK_StockLocation_ID,
                        DepotQuantity: detail.vc_UnitOfSale,
                        StockType: detail.StockType || 0,
                        IsAlreadyShipped: detail.IsAlreadyShipped || 0
                    };
                }));

                return selectedPartsData;
            }
        } catch (error) {
            console.error('Error fetching invoice details:', error);
        }
    };

    const handleShipInvoice = async (event, ID) => {
        event.stopPropagation();
        try {
            debugger;
            const redirectCallback = () => navigate('/');
            const lisoffCustomers = await CustomerService.GetAllCustomers(redirectCallback);
            const saleOrderDetail = await fetchInvoiceDetail(ID);
            const selectedCustomer = lisoffCustomers.find(customer => customer.ClientCompanyID === parseInt(saleOrderDetail.CustomerID));
            const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback);
            const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
            const ConversionRate = await convertCurrency(listOfCurreny[0].Symbol, selectedCustomer.vc_CurrencySymbol, currencyData, "0");
            const InvoiceItemsList = await fetchInvoiceItems(ID, selectedCustomer.vc_CurrencySymbol, ConversionRate);
            return InvoiceItemsList;

        } catch (error) {
            console.error("Error during purchase order process:", error);
        }
    }


    return { handleShipInvoice };
};
export default ShipInvoice;